import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Api3Service } from "./api3.service";
import { Api } from "./api.service";

@Injectable({ providedIn: "root" })
export class TablePreferencesService {

    public constructor(private api3Service: Api3Service, private router: Router) {}

    private detectScopeFromRoute(): { scope_type: string, scope_slug: string | null } {
        try {
            const url = this.router.url;
            const segments = url.split("/").filter(segment => segment);
            
            if (segments[0] === "admin") {
                return { scope_type: "admin", scope_slug: null };
            }
            if (segments[0] === "partner" && segments[1]) {
                return { scope_type: "partner", scope_slug: segments[1] };
            }
            if (segments[0] === "warehouse" && segments[1]) {
                return { scope_type: "warehouse", scope_slug: segments[1] };
            }
            if (segments[0] === "threepl" && segments[1]) {
                return { scope_type: "threepl", scope_slug: segments[1] };
            }
            return { scope_type: "partner", scope_slug: null };
        } catch {
            return { scope_type: "partner", scope_slug: null };
        }
    }

    public async getSearchIn(tableId: string, userId: string | number): Promise<string[] | null> {
        if (!tableId) {
            return null;
        }
        const { scope_type, scope_slug } = this.detectScopeFromRoute();
        const response: Api.IResponse = await this.api3Service.request(
            Api.EMethod.Get,
            `user/preferences/tables/${tableId}`,
            {},
            { user_id: userId, scope_type, scope_slug }
        );
        return (response && (response as any).data && (response as any).data.search_in)
            ? (response as any).data.search_in as string[]
            : null;
    }

    public async saveSearchIn(tableId: string, selected: string[], userId: string | number): Promise<boolean> {
        if (!tableId) {
            return false;
        }
        const { scope_type, scope_slug } = this.detectScopeFromRoute();
        const response: Api.IResponse = await this.api3Service.request(
            Api.EMethod.Put,
            `user/preferences/tables/${tableId}`,
            { search_in: selected || [], user_id: userId, scope_type, scope_slug }
        );
        return !!response;
    }
}


